import { render, staticRenderFns } from "./QuestionImgAbcd.vue?vue&type=template&id=13918ea2&"
import script from "./QuestionImgAbcd.vue?vue&type=script&lang=ts&"
export * from "./QuestionImgAbcd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports